import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from '@core/services/loader.service';
import { Observable } from 'rxjs';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loaderService: LoaderService) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    if (this.requests.length) {
      this.loaderService.show();
    } else {
      this.loaderService.hide();
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('api/worker/notification') 
    && !req.url.includes('api/notification')
    && !req.url.includes('api/socket/getUserMessage')
    && !req.url.includes('api/socket/getChatUsers') 
    && !req.url.includes('api/integration/getChildCardView')
    && !req.url.includes('api/integration/contactLog/narrative')
    && !req.url.includes('api/integration/medicaidInfo') 
    && !req.url.includes('api/notification/count')
  ) {
      this.requests.push(req);
      this.loaderService.show();
    }
    return new Observable((observer: any) => {
      const subscription = next.handle(req).subscribe({
        next: (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        error: (err) => {
          this.removeRequest(req);
          observer.error(err);
        },
        complete: () => {
          this.removeRequest(req);
          observer.complete();
        }
      });

      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });

  }
}
